import MensagemHistorico from './MensagemHistorico'

export default MensagemHistorico